import * as React from 'react'
import { styled } from '@mui/material/styles'

export const ColorizedContainer = styled('div')`
    display: block;
    text-align: left;
    font-weight: normal;
    background-color: ${({ theme }) => theme.palette.divider};
    color: ${({ theme }) => theme.palette.text.primary};
    border-radius: ${({ theme }) => `${theme.shape.borderRadius}px`};
    font-size: 1rem;
    padding: 1rem;
    overflow-wrap: break-word;
    white-space: pre-wrap;
    .highlight-me {
        width: calc(100% + 32px);
        display: inline-block;
        background: #2b2d40;
        border-left: 3px solid ${({ theme }) => theme.palette.secondary.main};
        margin-left: -16px;
        padding-left: 13px;
    }
`

const FallbackCodeBlock = ({ children }: { children: React.ReactNode }) => {
    return (
        <pre>
            <code>
                <ColorizedContainer>{children}</ColorizedContainer>
            </code>
        </pre>
    )
}

export default FallbackCodeBlock
